module.exports = __webpack_public_path__ + "static/img/indexSoftware4.248a816.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/indexSoftware4.png
// module id = WXxn
// module chunks = 2